
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomumbaidzirecab() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Dzire Cab',
        heading: 'Prince Cabs: Pune to Mumbai Dzire Cab',
        headingDescription: 'Prince Cabs provides affordable Pune to Mumbai Dzire Cab services, ideal for airport transfers, business trips, family travel, and weekend journeys. Our well-maintained Swift Dzire cars are fuel-efficient, comfortable, and perfect for budget-friendly long-distance travel on the Pune–Mumbai Expressway. With professional chauffeurs, on-time pickups, and flexible schedules, we ensure a smooth and hassle-free journey. Choose Prince Cabs’ trusted Swift Dzire cab service from Pune to Mumbai for comfort, safety, and convenience at the best fares.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924, the Gateway of India is Mumbai’s most iconic landmark overlooking the Arabian Sea. Designed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Ferries to Elephanta Caves depart from here, adding to its importance. The monument is surrounded by lively street vendors, photographers, and tourists. Sunset views here are stunning as the arch glows against the sea backdrop. It is the starting point of every Mumbai journey."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km promenade along the Arabian Sea. At night, the streetlights form a necklace-like pattern, giving it its famous name. Locals come here for evening strolls, jogging, and to enjoy the sea breeze. Monsoon waves crashing against the promenade are a dramatic sight. Sunsets here are among the most beautiful in Mumbai. Marine Drive represents the vibrant soul of the city."
  },
  {
    "title": "Elephanta Caves",
    "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island, accessible by a ferry from the Gateway of India. Dating back to the 5th–6th century, the caves house exquisite rock-cut sculptures of Lord Shiva, including the iconic Trimurti. The site blends history, spirituality, and artistry. Surrounded by lush greenery, it is a peaceful retreat from the city. Elephanta Caves are a must-visit for culture and heritage lovers."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly known as Victoria Terminus, is a UNESCO World Heritage Site and Mumbai’s busiest railway station. Built in Gothic Revival style in 1887, it features domes, stained glass, and intricate carvings. At night, the building is beautifully illuminated. It is both a transport hub and an architectural marvel. Tourists admire its grandeur while experiencing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s mix of heritage and modernity."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an engineering marvel connecting South Mumbai with its western suburbs. The 8-lane cable-stayed bridge offers breathtaking views of the Arabian Sea and skyline. Driving across the bridge is a thrilling experience. At night, its illuminated structure looks stunning. It has significantly reduced travel time for commuters. The Sea Link stands as a modern icon of Mumbai’s progress."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, known for its lively atmosphere and street food stalls. Vendors sell pav bhaji, bhel puri, and ice gola, making it a foodie’s paradise. Bollywood stars often reside nearby, attracting film fans. Families and tourists gather here in the evenings for sea breezes and sunsets. During weekends, the beach is filled with locals and visitors alike. Juhu is the perfect place to experience Mumbai’s coastal charm."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in the 15th century, Haji Ali Dargah is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is an example of Indo-Islamic architecture. The dargah is connected to the mainland by a narrow causeway accessible at low tide. Devotees from all faiths come here seeking blessings. Its sea-facing setting creates a spiritual and magical vibe. Haji Ali Dargah is both sacred and scenic."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Spread across 87 sq. km, Sanjay Gandhi National Park is a green haven in the heart of Mumbai. It is home to leopards, deer, and numerous bird species. Within the park lie the Kanheri Caves, ancient Buddhist rock-cut monasteries and stupas dating back to the 1st century BC. Trekkers, families, and nature lovers flock here for its trails and toy train rides. It is rare to find such biodiversity within a metro city. This destination blends history with nature."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market, famous for budget shopping and old-world charm. Tourists buy clothes, jewelry, handicrafts, and antiques here. It is also home to iconic cafés like Leopold Café and Café Mondegar. The area is always buzzing with energy, day and night. Colaba Causeway reflects Mumbai’s cosmopolitan spirit. Shopping here is a quintessential Mumbai experience."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Located in Prabhadevi, Siddhivinayak Temple is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it attracts thousands of devotees daily, including celebrities and politicians. The gold-plated dome and intricately carved wooden doors add grandeur. Tuesdays witness massive crowds of worshippers. It is believed that prayers here are always fulfilled. Siddhivinayak Temple is the spiritual heart of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for its Ganesh Visarjan celebrations. Families come here to enjoy street food like pav bhaji and kulfi. The beach is an evening hangout spot with views of Marine Drive. Cultural fairs and festivals make it vibrant throughout the year. It offers a mix of relaxation and festivities. Girgaon Chowpatty is deeply embedded in Mumbai’s social fabric."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood and television production. Spread over 500 acres, it has multiple studios, artificial sets, and shooting zones. Visitors can take guided tours to explore behind-the-scenes of movies and shows. Cinema enthusiasts love spotting shooting locations. Film City showcases Mumbai’s identity as the entertainment capital of India. It is a dream destination for Bollywood fans."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is a serene artificial lake surrounded by lush greenery and skyscrapers. It is a popular spot for birdwatching, with sightings of kingfishers, herons, and migratory birds. Locals enjoy morning walks and photography along the promenade. The lake is especially beautiful during monsoon with misty surroundings. It offers peace away from Mumbai’s chaos. Powai Lake is a hidden natural gem in the city."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda, located near Gorai, is one of the largest meditation domes in the world. Built in Burmese architectural style, it houses relics of Buddha. The golden dome can accommodate over 8,000 meditators at once. Visitors attend meditation sessions and admire its magnificent structure. The seaside location enhances its tranquility. It is a symbol of peace and spiritual enlightenment."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "The Nehru Planetarium in Worli is a hub for astronomy and science education. It offers immersive sky shows about stars, planets, and the universe. The adjoining Science Centre has interactive exhibits on technology and innovation. Families and students find it educational and entertaining. The dome-shaped auditorium also hosts cultural and scientific events. It inspires curiosity and learning in young minds."
  }
],

 "services": [
    {
      "name": "Pune to Mumbai Swift Dzire Rent",
      "description": "Book Swift Dzire taxi from Pune to Mumbai for a comfortable and smooth journey. Ideal for solo travelers, couples, and small families, this service offers affordable rates with professional drivers, clean vehicles, and reliable pickups."
    },
    {
      "name": "Pune to Nashik Swift Dzire per km Rate",
      "description": "Get competitive per km rental rates for Swift Dzire cabs from Pune to Nashik. Perfect for outstation trips, this pricing model offers transparency and flexibility, allowing you to pay only for the distance covered while enjoying a comfortable ride."
    },
    {
      "name": "Pune to Outstation Swift Taxi",
      "description": "Reliable and affordable Swift Dzire taxi service for outstation travel from Pune. Whether it’s business or leisure, our well-maintained vehicles and experienced drivers ensure a hassle-free and safe journey to your destination."
    },
    {
      "name": "Pune to Ashtavinayak Swift Dzire Cab",
      "description": "Explore the sacred Ashtavinayak temples comfortably with our Pune to Ashtavinayak Swift Dzire cab service. Enjoy door-to-door pickups, affordable packages, and experienced drivers who ensure timely and pleasant trips."
    },
    {
      "name": "Swift Dzire Car Hire Pune to Outstation",
      "description": "Hire Swift Dzire cabs from Pune for outstation trips with flexible rental options. Perfect for weekend getaways or business travels, our service guarantees well-maintained cars, courteous drivers, and affordable pricing."
    },
    {
      "name": "4 Seater Car on Rent",
      "description": "Book a 4-seater Swift Dzire car for local or outstation travel. Comfortable for small groups and families, this option combines economy with convenience for any kind of trip starting from Pune."
    },
    {
      "name": "Pune to Mumbai Dzire Cab Fare",
      "description": "Check transparent and affordable Dzire cab fares for travel between Pune and Mumbai. Our competitive pricing ensures you get value without compromising comfort or service quality."
    },
    {
      "name": "Pune to Mumbai Dzire Cab Booking",
      "description": "Easily book a Dzire cab from Pune to Mumbai with online or phone booking options. Enjoy hassle-free pickups, professional drivers, and clean, air-conditioned vehicles at the best rates."
    },
    {
      "name": "Affordable Dzire Pune to Mumbai",
      "description": "Avail affordable Swift Dzire taxi services from Pune to Mumbai without compromising on comfort or safety. Ideal for budget travelers seeking reliable transportation with great customer service."
    },
    {
      "name": "Luxury Dzire Pune to Mumbai",
      "description": "Travel in style and comfort with our luxury Dzire cab service from Pune to Mumbai. Perfect for corporate clients or special occasions, featuring premium interiors and experienced chauffeurs."
    },
    {
      "name": "Pune to Mumbai Dzire Family Cab",
      "description": "Book a family-friendly Swift Dzire cab for your Pune to Mumbai trip. Spacious, comfortable, and safe, this service caters to families looking for a relaxed and secure travel experience."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Swift Dzire Rent", "Pune to Nashik Swift Dzire per km Rate"],
    ["Pune to Outstation Swift Taxi", "Pune to Ashtavinayak Swift Dzire Cab"],
    ["Swift Dzire Car Hire Pune to Outstation", "4 Seater Car on Rent"],
    ["Pune to Mumbai Dzire Cab Fare", "Pune to Mumbai Dzire Cab Booking"],
    ["Affordable Dzire Pune to Mumbai", "Luxury Dzire Pune to Mumbai"],
    ["Pune to Mumbai Dzire Family Cab"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Dzire Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable Swift Dzire cab service from Pune to Mumbai, perfect for corporate travelers, tourists, and small groups seeking a comfortable and efficient journey between these two bustling cities. Our Dzire cabs ensure a smooth, fuel-efficient ride across the approximately 150 km route, minimizing travel stress."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Sedans",
        "WhyChoosedescription": "Our Swift Dzire vehicles feature spacious seating for up to four passengers, ample legroom, clean interiors, and effective air conditioning. Whether you are heading to a business meeting or a weekend getaway, our well-maintained cabs make your journey enjoyable and relaxing."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
        "WhyChoosedescription": "Our professional drivers are familiar with the fastest and safest routes between Pune and Mumbai, adept at navigating traffic and ensuring timely pickups and drop-offs. They prioritize your safety and convenience throughout the trip."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Schedule",
        "WhyChoosedescription": "Prince Cabs offers flexible rental packages, including one-way trips, round trips with waiting time, and multi-day rentals for extended stays in Mumbai or Pune. Booking is simple via phone, WhatsApp, or online, with instant confirmation and transparent policies."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "Our Pune to Mumbai Dzire cab service comes with upfront, competitive pricing covering all charges such as fuel, tolls, and driver allowances. Choose your preferred payment method, including UPI, credit/debit cards, net banking, or cash."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Measures",
        "WhyChoosedescription": "Each Dzire cab undergoes thorough cleaning and sanitization before and after every journey. We ensure that our fleet is regularly serviced and equipped with necessary safety features like seat belts and airbags for your peace of mind."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Seamless Travel",
        "WhyChoosedescription": "Our dedicated customer care team is available round-the-clock to assist you with bookings, itinerary adjustments, or any travel-related concerns, ensuring a hassle-free and comfortable Pune to Mumbai travel experience."
    }
]


























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Swift Dzire cab service from Pune to Mumbai?',
        answer: 'Yes, Prince Cabs provides comfortable and affordable Swift Dzire cabs for travel between Pune and Mumbai, suitable for business and leisure trips.',
    },
    {
        question: 'What is the fare for Pune to Mumbai Swift Dzire cab?',
        answer: 'The fare usually starts from ₹3,000 for a one-way trip, varying based on pickup location, time, and any additional stops.',
    },
    {
        question: 'How long does the Pune to Mumbai journey take by Swift Dzire?',
        answer: 'The travel time ranges from 3 to 4 hours depending on traffic and route conditions.',
    },
    {
        question: 'Is Swift Dzire comfortable for long-distance travel like Pune to Mumbai?',
        answer: 'Yes, the Swift Dzire offers comfortable seating, good mileage, and sufficient luggage space, making it ideal for long-distance trips.',
    },
    {
        question: 'Can I book a round-trip Swift Dzire cab from Pune to Mumbai?',
        answer: 'Absolutely! We offer flexible one-way and round-trip options tailored to your travel needs.',
    },
    {
        question: 'Are the Swift Dzire cabs sanitized and well-maintained?',
        answer: 'Yes, all our Swift Dzire vehicles are regularly cleaned, sanitized, and inspected to ensure your safety and comfort.',
    },
    {
        question: 'How do I book a Swift Dzire cab from Pune to Mumbai?',
        answer: 'You can easily book through our website or by calling Prince Cabs with your travel details to confirm your reservation.',
    },
];

const testimonials = [
    {
        name: "Mr. Rohit Mehta",
        position: "Business Traveler",
        text: "The Swift Dzire cab from Pune to Mumbai by Prince Cabs was comfortable and punctual. Great service for regular travelers like me.",
        image: "/img/testimonial/testimonial-thumb-dzire-mumbai-1.png",
    },
    {
        name: "Ms. Kavita Sharma",
        position: "Leisure Traveler",
        text: "I enjoyed my Pune to Mumbai trip in a Swift Dzire cab. The driver was professional, and the ride was smooth and relaxing.",
        image: "/img/testimonial/testimonial-thumb-dzire-mumbai-2.png",
    },
];
































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mumbai Dzire Cab",
  "description": "Affordable and luxury Swift Dzire cab service from Pune to Mumbai with options for outstation trips, family cabs, and convenient booking.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Mumbai Swift Dzire Rent",
    "Pune to Nashik Swift Dzire per km Rate",
    "Pune to Outstation Swift Taxi",
    "Pune to Ashtavinayak Swift Dzire Cab",
    "Swift Dzire Car Hire Pune to Outstation",
    "4 Seater Car on Rent",
    "Pune to Mumbai Dzire Cab Fare",
    "Pune to Mumbai Dzire Cab Booking",
    "Affordable Dzire Pune to Mumbai",
    "Luxury Dzire Pune to Mumbai",
    "Pune to Mumbai Dzire Family Cab"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};


    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Dzire Cab | Affordable Swift Dzire Taxi Service</title>
  <meta
    name="description"
    content="Affordable and luxury Swift Dzire cab service from Pune to Mumbai with options for outstation trips, family cabs, and convenient booking."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Swift Dzire Rent, Pune to Nashik Swift Dzire per km Rate, Pune to Outstation Swift Taxi, Pune to Ashtavinayak Swift Dzire Cab, Swift Dzire Car Hire Pune to Outstation, 4 Seater Car on Rent, Pune to Mumbai Dzire Cab Fare, Pune to Mumbai Dzire Cab Booking, Affordable Dzire Pune to Mumbai, Luxury Dzire Pune to Mumbai, Pune to Mumbai Dzire Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaidzirecab ;